import script from "./AdminProductsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminProductsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminProductsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__